'use client';

import { useTranslations } from 'next-intl';

import { Breadcrumb } from '@/components/breadcrumb';
import { BreadcrumbItem } from '@/components/breadcrumb/breadcrumb-item';
import SecondaryHeading from '@/components/typography/SecondaryHeading';
import { useRouter } from '@/hooks/useRouter';
import { SimpleLocationDto } from '@/lib/locations/dto';

import { ContactUsLayout } from './ContactUsLayout';
import { FormFactory } from './forms/FormFactory';
import { ContactOptions } from './types';

type ContactUsFormPageProps = {
  option: ContactOptions;
  allLocations: SimpleLocationDto[];
};

export function ContactUsFormPage({
  option,
  allLocations,
}: ContactUsFormPageProps) {
  const t = useTranslations('contact-us');
  const router = useRouter();

  const breadcrumbItems: BreadcrumbItem<string>[] = [
    {
      label: t(`go-back`),
      value: '',
    },
    {
      label: t(`${option}.step-name`),
      value: option,
    },
  ];

  return (
    <ContactUsLayout>
      <Breadcrumb
        className="lg:mt-[-20px] mb-5"
        items={breadcrumbItems}
        currentItem={breadcrumbItems[1]}
        onItemClicked={() => router.push('/contact-us')}
      />
      <SecondaryHeading className="mb-5">
        {t(`${option}.form-title`)}
      </SecondaryHeading>

      <FormFactory option={option} allLocations={allLocations} />
    </ContactUsLayout>
  );
}
